import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../hooks/useFetchData";
import { eventGetPublishedByOthersActionHandler } from "../../../store/actions/actionHandlers/eventActionHandler";
import { eventPublishedByOthers } from "../../../utils/mainTabs/events/eventPublishedByOthers";

const EventPublishedByOthers = () => {
  const navigate = useNavigate();
  const pageSize = 8;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
    loading,
  } = useFetchData(eventGetPublishedByOthersActionHandler, pageSize);
  const { tenantName, refreshAPIS, setRefreshAPIS } = useOutletContext();
  const { searchPlaceHolder, columns } = eventPublishedByOthers;
  useEffect(() => {
    if (refreshAPIS) {
      handleSearchQuery("");
      setRefreshAPIS(false);
    }
  }, [refreshAPIS]);
  return (
    <DataTable
      columns={columns(navigate, tenantName)}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      uniqueFieldName={"uniqueFieldName"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
      loading={loading}
    />
  );
};

export default EventPublishedByOthers;
